// extracted by mini-css-extract-plugin
export default {"cs_button":"customer_cs_button__-UIEE","firstBtn":"customer_firstBtn__QAhgU"};